import Box from '@mui/material/Box';

const Scene = ({ className = undefined, noBar = false, ...props }) => {
  return (
    <Box
      sx={[
        noBar
          ? {
              height: 'calc(100vh - 105px)',
              overflowY: 'none',
            }
          : { height: 'calc(100vh - 168px)', overflowY: 'auto' },
      ]}
    >
      <Box
        className={className}
        sx={[
          {
            overflowX: 'hidden',
          },
        ]}
        {...props}
      />
    </Box>
  );
};

export default Scene;
